import { createTheme } from '@mui/material/styles';

const palette = {
  primary: { main: '#1565C0', light: '#5E92F3', dark: '#003C8F', contrastText: '#FFFFFF' },
  secondary: { main: '#00897B', light: '#4EBAAA', dark: '#005B4F', contrastText: '#FFFFFF' },
  error: { main: '#D32F2F' },
  warning: { main: '#ED6C02' },
  info: { main: '#0288D1' },
  success: { main: '#2E7D32' },
};

const sharedTypography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h4: { fontWeight: 700, fontSize: '1.75rem' },
  h5: { fontWeight: 600, fontSize: '1.25rem' },
  h6: { fontWeight: 600, fontSize: '1rem' },
  subtitle1: { fontWeight: 600 },
  body2: { fontSize: '0.875rem' },
  caption: { fontSize: '0.75rem' },
};

const sharedComponents = {
  MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 500, borderRadius: 8 } } },
  MuiCard: { styleOverrides: { root: { borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' } } },
  MuiPaper: { styleOverrides: { rounded: { borderRadius: 12 } } },
  MuiTableCell: { styleOverrides: { head: { fontWeight: 600, backgroundColor: 'action.hover' } } },
  MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
  MuiTextField: { defaultProps: { size: 'small' } },
  MuiDrawer: { styleOverrides: { paper: { borderRadius: 0 } } },
};

export const lightTheme = createTheme({
  palette: { mode: 'light', ...palette, background: { default: '#F0F4F8', paper: '#FFFFFF' }, divider: '#E2E8F0' },
  typography: sharedTypography,
  shape: { borderRadius: 8 },
  components: sharedComponents,
});

export const darkTheme = createTheme({
  palette: { mode: 'dark', ...palette, background: { default: '#0B1120', paper: '#151E2E' }, divider: '#2D3748' },
  typography: sharedTypography,
  shape: { borderRadius: 8 },
  components: sharedComponents,
});
